
import { mapState } from 'vuex'
import IndexPc from '~/components/senior-user/index-pc.vue'
import IndexMobile from '~/components/senior-user/index-mobile.vue'
import { sendPayClue } from '~/api/package-about.js'

export default {
  name: 'SeniorUser',
  components: {
    IndexPc,
    IndexMobile
  },
  layout: 'scence-single',
  computed: {
    ...mapState(['isMobile']),
    loggedIn() {
      return this.$store.state.loginStatus.loggedIn == 1
    }
  },
  mounted() {
    this.doSendPayClue()
  },
  methods: {
    doSendPayClue() {
      if (!this.loggedIn) {
        return
      }
      const _stayTimer = setTimeout(function () {
        clearTimeout(_stayTimer)
        // 发送付费套餐线索
        sendPayClue({
          clue_tag_list: ['浏览套餐介绍页'],
          clue_resource: '浏览套餐相关页面'
        })
      }, 30000)
    }
  }
}
